import React from "react";
import Carousel from "react-multi-carousel";

import Amala from "../../assets/feedbacks/amala.jpg";
import Ajibest from "../../assets/feedbacks/ajibest.jpg";
import Indomart from "../../assets/feedbacks/indomart.jpg";
import ThriftPerfs from "../../assets/feedbacks/perfs.jpg";
import ScentPalace from "../../assets/feedbacks/scent-palace.JPG";


const Feedback = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  // Generate random ratings for each feedback item
  const getRandomRating = () => Math.floor(Math.random() * 5) + 1;

  return (
    <section
      data-aos="fade-up"
      data-aos-duration="1500"
      className="container-fluid"
      style={{ background: "#ff6503", position: "relative", padding: "3em" }}
    >
      <div className="container pt-5">
        <div className="row">
          <div className="col-md-12">
            <h4 className="text-white">Our Customers feedback</h4>
            <p className=" text-white">
              Don’t take our word for it. Trust our customers
            </p>
          </div>
          <div className="col-md-12">
            <Carousel
              showDots={true}
              responsive={responsive}
              removeArrowOnDeviceType={["tablet", "mobile"]}
            >
              {/* Feedback Item 1 */}
              <div
                style={{
                  background: "white",
                  width: "95%",
                  height: "18em",
                  padding: "19px",
                  borderRadius: " 6px",
                }}
              >
                <div className="">
                  <img
                    className=""
                    width={50}
                    src={Amala}
                    alt="profile pics"
                  />
                  <span
                    className="float-end"
                    style={{
                      fontSize: "20px",
                      color: "#ff6503",
                      marginRight: "5px",
                    }}
                  >
                    {"★".repeat(getRandomRating())}
                  </span>
                </div>
                <div>
                  <p className="fw-bolder">Amala Campus</p>
                  <small className="text-black">
                    “At Amala Campus, we truly understand the meaning of comfort
                    food! Thanks to Nuprex Logistics’ swift delivery services,
                    customers can now enjoy their favorite dishes hot and fresh,
                    right at their doorstep. Amala Campus is the go-to spot for
                    authentic flavors, and we’re proud to partner with them to
                    ensure no meal is delayed!”
                  </small>
                </div>
              </div>

              {/* Feedback Item 2 */}
              <div
                style={{
                  background: "white",
                  width: "95%",
                  height: "18em",
                  padding: "19px",
                  borderRadius: " 6px",
                }}
              >
                <div className="">
                  <img
                    className=""
                    width={50}
                    src={Indomart}
                    alt="profile pics"
                  />
                  <span
                    className="float-end"
                    style={{
                      fontSize: "20px",
                      color: "#ff6503",
                      marginRight: "5px",
                    }}
                  >
                    {"★".repeat(getRandomRating())}
                  </span>
                </div>
                <div>
                  <p className="fw-bolder">Indomart Supermarket</p>
                  <small className="text-black">
                    “Indomart Supermarket has redefined convenience shopping
                    with their wide range of everyday essentials. With Nuprex
                    Logistics as our trusted delivery partner, customers can
                    enjoy a seamless shopping experience from store to door.
                    Indomart and Nuprex—together, we bring the market to your
                    home!”
                  </small>
                </div>
              </div>

              {/* Feedback Item 3 */}
              <div
                style={{
                  background: "white",
                  width: "95%",
                  height: "18em",
                  padding: "19px",
                  borderRadius: " 6px",
                }}
              >
                < div className="">
                  <img
                    className=""
                    width={50}
                    src={Ajibest}
                    alt="profile pics"
                  />
                  <span
                    className="float-end"
                    style={{
                      fontSize: "20px",
                      color: "#ff6503",
                      marginRight: "5px",
                    }}
                  >
                    {"★".repeat(getRandomRating())}
                  </span>
                </div>
                <div>
                  <p className="fw-bolder">Ajibest Stores</p>
                  <small className="text-black">
                    “Ajibest Stores combines affordability and quality in a way
                    that keeps customers coming back. With Nuprex Logistics
                    handling our timely deliveries, customers are always
                    guaranteed a stress-free experience. Ajibest Stores and
                    Nuprex—the perfect duo for hassle-free shopping!”
                  </small>
                </div>
              </div>

              {/* Feedback Item 4 */}
              <div
                style={{
                  background: "white",
                  width: "95%",
                  height: "18em",
                  padding: "19px",
                  borderRadius: " 6px",
                }}
              >
                <div className="">
                  <img
                    className=""
                    width={50}
                    src={ThriftPerfs}
                    alt="profile pics"
                  />
                  <span
                    className="float-end"
                    style={{
                      fontSize: "20px",
                      color: "#ff6503",
                      marginRight: "5px",
                    }}
                  >
                    {"★".repeat(getRandomRating())}
                  </span>
                </div>
                <div>
                  <p className="fw-bolder">Thrift Perfumes</p>
                  <small className="text-black">
                    “Thrift Perfumes delivers elegance in a bottle, and with
                    Nuprex Logistics as our delivery partner, our scents now
                    travel faster than ever! Whether you’re gifting a loved one
                    or treating yourself, Thrift Perfumes and Nuprex ensure your
                    fragrance arrives perfectly and on time.”
                  </small>
                </div>
              </div>

              {/* Feedback Item 5 */}
              <div
                style={{
                  background: "white",
                  width: "95%",
                  height: "18em",
                  padding: "19px",
                  borderRadius: " 6px",
                }}
              >
                <div className="">
                  <img
                    className=""
                    width={50}
                    src={ScentPalace}
                    alt="profile pics"
                  />
                  <span
                    className="float-end"
                    style={{
                      fontSize: "20px",
                      color: "#ff6503",
                      marginRight: "5px",
                    }}
                  >
                    {"★".repeat(getRandomRating())}
                  </span>
                </div>
                <div>
                  <p className="fw-bolder">Scent Palace</p>
                  <small className="text-black">
                    “Scent Palace brings luxury and sophistication to your
                    senses. With Nuprex Logistics managing our deliveries, every
                    customer enjoys prompt service, ensuring they receive their
                    favorite perfumes without delay. Scent Palace and Nuprex
                    Logistics—a partnership that smells like success!”
                  </small>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Feedback;